import React, {useEffect,} from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';
import ValtekEcLayout from './context/ValtekEcLayout';
import {AuthProvider, useAuth} from './context/AuthContext'; // Bunu da ekle!
//import '../app/valtek-ec/css/bootstrap-select.min.css';
//import "../src/valtek-ec/scss/main.scss";
// import "../src/scss/main.scss";
import "../src/assets/scss/main.scss";

import './App.css';
import {ToastContainer} from "react-toastify";
import AdminSpinner from "./valtek-ec/components/AdminSpinner";

import {setupAxios} from "./shared/AxiosConfig";
import {toast} from "react-toastify";


function AppEffects() {
    const {pathname} = useLocation();

    useEffect(() => {
        const cartModal = document.getElementById("shoppingCart");
        if (cartModal && window.bootstrap?.Offcanvas) {
            const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(cartModal);
            if (bsOffcanvas) bsOffcanvas.hide();
        }
    }, [pathname]);

    useEffect(() => {
        if (typeof window !== "undefined") {
            // Import the script only on the client side
            //import("bootstrap/dist/js/bootstrap.esm").then(() => {
            // Module is imported, you can access any exported functionality if
            //});
        }
    }, []);

    // Scroll davranışı
    useEffect(() => {
        let lastScrollTop = 0;
        const delta = 5;
        let navbarHeight = 0;
        let didScroll = false;
        const header = document.querySelector("header");

        const handleScroll = () => {
            didScroll = true;
        };

        const checkScroll = () => {
            if (didScroll && header) {
                const st = window.scrollY || document.documentElement.scrollTop;
                navbarHeight = header.offsetHeight;

                if (st > navbarHeight) {
                    if (st > lastScrollTop + delta) {
                        header.style.top = `-${navbarHeight}px`;
                    } else if (st < lastScrollTop - delta) {
                        header.style.top = "0";
                        header.classList.add("header-bg");
                    }
                } else {
                    header.style.top = "";
                    header.classList.remove("header-bg");
                }

                lastScrollTop = st;
                didScroll = false;
            }
        };

        if (header) {
            navbarHeight = header.offsetHeight;
        }

        window.addEventListener("scroll", handleScroll);
        const scrollInterval = setInterval(checkScroll, 250);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            clearInterval(scrollInterval);
        };
    }, [pathname]);

    // Açık modal ve offcanvas'ları kapat (CDN ile gelen Bootstrap üzerinden)
    // useEffect(() => {
    //     const modalElements = document.querySelectorAll(".modal.show");
    //     modalElements.forEach((modal) => {
    //         const modalInstance = window.bootstrap?.Modal.getInstance(modal);
    //         if (modalInstance) modalInstance.hide();
    //     });
    //
    //     const offcanvasElements = document.querySelectorAll(".offcanvas.show");
    //     offcanvasElements.forEach((offcanvas) => {
    //         const offcanvasInstance = window.bootstrap?.Offcanvas.getInstance(offcanvas);
    //         if (offcanvasInstance) offcanvasInstance.hide();
    //     });
    // }, [pathname]);
    // useEffect(() => {
    //     // Dynamically import Bootstrap
    //     import("bootstrap")
    //         .then((bootstrap) => {
    //             // Close any open modal
    //             const modalElements = document.querySelectorAll(".modal.show");
    //             modalElements.forEach((modal) => {
    //                 const modalInstance = bootstrap.Modal.getInstance(modal);
    //                 if (modalInstance) {
    //                     modalInstance.hide();
    //                 }
    //             });
    //
    //             // Close any open offcanvas
    //             const offcanvasElements = document.querySelectorAll(".offcanvas.show");
    //             offcanvasElements.forEach((offcanvas) => {
    //                 const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvas);
    //                 if (offcanvasInstance) {
    //                     offcanvasInstance.hide();
    //                 }
    //             });
    //         })
    //         .catch((error) => {
    //             console.error("Error loading Bootstrap:", error);
    //         });
    // }, [pathname]); // Runs every time the route changes

    // WOW.js scroll animasyonları (CDN'den yüklü varsayılıyor)
    useEffect(() => {
        if (window.WOW) {
            const wow = new window.WOW({mobile: false, live: false});
            wow.init();
        }
    }, [pathname]);

    return null;
}

function AppContent() {
    const {loading} = useAuth();
    const auth = useAuth();     // 🔥 auth burada geliyor
    useEffect(() => {
        setupAxios(auth); // ✔ SADECE 1 KEZ
    }, []);

    useEffect(() => {
        const ctx = window.APP_CART_CONTEXT;
        if (ctx?.reloadCart) {
            // console.log("♻ Refresh sonrası sepet yükleniyor");
            ctx.reloadCart();
        }
    }, []);

    const location = useLocation();
    useEffect(() => {
        const msg = localStorage.getItem("logoutMessage");
        if (msg) {
            toast.error(msg, {toastId: "global-logout"});
            localStorage.removeItem("logoutMessage");
        }
    }, [location.pathname]);

    useEffect(() => {
        let guid = localStorage.getItem("cart_guid");
        if (!guid) {
            guid = crypto.randomUUID();
            localStorage.setItem("cart_guid", guid);
            // console.log("🛒 Cart GUID oluşturuldu:", guid);
        } else {
            // console.log("🛒 Var olan Cart GUID:", guid);
        }
    }, []);


    // if (loading) return <AdminSpinner />;


    if (loading) return <AdminSpinner/>;

    return (
        <>
            <AppEffects/>
            <Routes>
                <Route path="/*" element={<ValtekEcLayout/>}/>
            </Routes>

            <ToastContainer
                position="top-left"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                theme="dark"
            />

        </>
    );
}

function App() {


    return (
        <Router>
            <AuthProvider>
                <AppContent/> {/* ✅ Artık useAuth() burada çalışır */}
            </AuthProvider>
        </Router>
    );
}

export default App;
